<template>
    <v-container class="mb-6">

        <div class="text-right mb-5">
            <v-btn
                color="primary"
                :x-large="!$vuetify.breakpoint.smAndDown"
                class="mr-4"
                @click="dialogPurchase=!dialogPurchase"
                :disabled="cantProds<=0"
            >Pedir</v-btn>
            <v-badge
                :content="cantProds"
                :value="cantProds"
                color="primary"
                overlap
            >
                <v-btn color="primary" outlined :x-large="!$vuetify.breakpoint.smAndDown" @click="openCart=!openCart">
                    Carrito
                </v-btn>
            </v-badge>
        </div>

        <!-- card main -->
        <v-card>
            <v-card-title>
                Lista de Productos
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar producto..."
                    outlined
                    dense
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="listProducts"
                :search="search"
            >
                <template v-slot:item.name="{ item }">
                    <v-list-item class="px-0">
                        <v-list-item-avatar class="rounded-0" height="60" width="60">
                            <v-img
                                :src="item.banner"
                                aspect-ratio="1.7"
                                contain
                            ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.name }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <template v-slot:item.type="{ item }">
                    <span>{{ (item.type=='service')?'Servicio':'Producto' }}</span>
                </template>
                <template v-slot:item.categories="{ item }">
                    <ul>
                        <li v-for="(cat, m) in item.categories" :key="m">
                            {{ cat.name }}
                        </li>
                    </ul>
                </template>
                <template v-slot:item.quantity="{ item }">
                    <div class="d-flex align-center justify-center">
                        <v-btn icon small @click="changePlusAndMinusTable('minus', item.index)" :disabled="item.quantity<=0">
                            <v-icon dark>
                                mdi-minus
                            </v-icon>
                        </v-btn>
                        <v-text-field
                            placeholder="Cantidad"
                            color="primary"
                            outlined
                            dense
                            type="number"
                            min="1"
                            step="1"
                            :max="stock"
                            hide-details
                            v-model="item.quantity"
                            style="width:100px;max-width:100px;"
                            class="text-center in-center"
                            @input="changeQuantityTable($event, item.index)"
                        ></v-text-field>
                        <v-btn icon small @click="changePlusAndMinusTable('plus', item.index)" :disabled="item.quantity>=stock">
                            <v-icon dark>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </div>
                </template>
                <template v-slot:item.price="{ item }">
                    <span class="title" v-if="item.price">
                        <v-text-field
                            placeholder="Precio"
                            color="primary"
                            outlined
                            dense
                            type="number"
                            min="1"
                            hide-details
                            v-model="item.price"
                            style="width:100px;max-width:100px;"
                            class="text-center in-center"
                            @input="changePriceCall($event, item.index)"
                            v-if="changePrice"
                        >
                            <template v-slot:prepend>
                                <span>{{ money }}</span>
                            </template>
                        </v-text-field>
                        <span v-else>
                            {{ money }} {{ (item.quantity>0)?(item.price*item.quantity):item.price }}
                        </span>
                    </span>
                </template>
            </v-data-table>
        </v-card>

        <!-- <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                Lista de Productos
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            Producto
                        </th>
                        <th class="text-left">
                            Tipo
                        </th>
                        <th class="text-left">
                            Categoría
                        </th>
                        <th class="text-right">
                            Precio
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, index) in listProducts">
                        <tr :key="index" @click="openDetails(item.id)" style="cursor: pointer;" v-if="item.type!=='service'">
                            <td>
                                <v-list-item class="px-0">
                                    <v-list-item-avatar class="rounded-0" height="60" width="60">
                                        <v-img
                                            :src="item.banner"
                                            aspect-ratio="1.7"
                                            contain
                                        ></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ item.name }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </td>
                            <td>{{ (item.type=='service')?'Servicio':'Producto' }}</td>
                            <td>{{ item.category.name }}</td>
                            <td class="text-right">
                                <div v-if="item.price">
                                    <div class="mb-2 text-right" v-if="item.special_price">
                                        <span class="font-weight-light text-decoration-line-through grey--text">
                                            {{ item.price }} {{ money }}
                                        </span>
                                        <span class="title">
                                            {{ item.special_price }} {{ money }}
                                        </span>
                                    </div>
                                    <div class="mb-2 text-right" v-else>
                                        <span class="title">
                                            {{ item.price }} {{ money }}
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination> -->
        <!-- end card main -->

        <!-- dialog -->
        <v-dialog
            v-model="dialogProd"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-skeleton-loader
                v-if="loadProd"
                class="white"
                type="card-avatar, article, actions"
            ></v-skeleton-loader>
            <v-card
                v-else
                class="mx-auto"
            >
                <v-overlay
                    absolute
                    :value="overlayProd"
                    opacity=".8"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="success"
                    ></v-progress-circular>
                </v-overlay>
                <v-fab-transition>
                    <v-btn
                        absolute
                        right
                        fab
                        small
                        style="top: 10px;"
                        @click="dialogProd=!dialogProd, loadProd=!loadProd"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-fab-transition>

                <v-card-text class="pb-5 px-0">
                    <v-card-title class="pa-0">
                        <v-carousel
                            height="auto"
                            class="simple-carousel"
                            :show-arrows="(galleryProd.length<=0)?false:true"
                            hide-delimiters
                            style="min-height: 250px;"
                            v-if="bannerProd != 'none'"
                        >
                            <v-carousel-item
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="bannerProd"
                                    :lazy-src="bannerProd"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="primary"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                            <v-carousel-item
                                v-for="(img, j) in galleryProd" :key="j"
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="img.img"
                                    :lazy-src="img.img"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="primary"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                        </v-carousel>
                        <div class="px-4 py-2" style="width:100%">
                            {{ nameProd }}
                        </div>
                    </v-card-title>

                    <div class="px-5 mb-5" v-if="descriptionProd" v-html="descriptionProd"></div>

                    <v-divider></v-divider>

                    <!-- services -->
                    <v-card v-if="typeProd=='service'" tile elevation="0">
                        <v-card-text class="pa-0">
                            <v-card-title class="py-3 blue-grey lighten-5">
                                Reserva tu hora
                            </v-card-title>
                            <v-form ref="refService" lazy-validation class="pa-3">
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            label="Nombre completo *"
                                            color="primary"
                                            outlined
                                            dense
                                            v-model="fullName"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            label="Número de celular *"
                                            color="primary"
                                            outlined
                                            dense
                                            v-model="phoneNumber"
                                            type="number"
                                            :rules="[rules.required, rules.min]"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-dialog
                                            ref="dialog"
                                            v-model="menu1"
                                            :return-value.sync="dateFormatted"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <!-- @blur="dateReservation = parseDate(dateFormatted)" -->
                                            <v-text-field
                                                v-model="dateFormatted"
                                                label="Fecha *"
                                                append-icon="mdi-calendar"
                                                dense
                                                outlined
                                                readonly
                                                color="primary"
                                                :rules="[rules.required]"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="dateReservation"
                                                locale="es-Bo"
                                                color="primary"
                                                class="ma-0"
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="menu1 = false"
                                                >
                                                    Cancelar
                                                </v-btn>
                                                <v-btn
                                                    color="primary"
                                                    @click="$refs.dialog.save(formatDate(dateReservation))"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-dialog
                                            ref="dialog2"
                                            v-model="menu2"
                                            :return-value.sync="timeReservation"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="timeReservation"
                                                label="Hora *"
                                                append-icon="mdi-clock-time-four-outline"
                                                readonly
                                                outlined
                                                dense
                                                color="primary"
                                                :rules="[rules.required]"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="menu2"
                                                v-model="timeReservation"
                                                full-width
                                                color="primary"
                                                class="ma-0"
                                            >
                                                <!-- format="24hr" -->
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="menu2 = false"
                                                >
                                                    Cancelar
                                                </v-btn>
                                                <v-btn
                                                    color="primary"
                                                    @click="$refs.dialog2.save(timeReservation)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-time-picker>
                                        </v-dialog>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </v-card>

                    <!-- <div class="px-3 pt-5">
                        <v-textarea
                            outlined
                            :placeholder="(typeProd=='service')?'Incluir un comentario para la reserva':'Dato extra'"
                            color="primary"
                            rows="3"
                            v-model="dataExtra"
                        ></v-textarea>
                    </div> -->

                </v-card-text>

                <v-card-actions v-if="ifNewProd">
                    <!-- product -->
                    <v-row no-gutters align="center" v-if="typeProd=='product'">
                        <v-col cols="6">
                            <div class="d-flex align-center">
                                <v-btn icon small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                    <v-icon dark>
                                        mdi-minus
                                    </v-icon>
                                </v-btn>
                                <v-text-field
                                    placeholder="Cantidad"
                                    color="primary"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    step="1"
                                    :max="stock"
                                    hide-details
                                    v-model="quantity"
                                    style="width:100px;max-width:100px;"
                                    @input="changeQuantity($event)"
                                ></v-text-field>
                                <v-btn icon small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-btn
                                large
                                block
                                rounded
                                color="primary"
                                @click="addToCart"
                                class="text-capitalize"
                            >
                                <strong>Agregar {{ money }} {{ (quantity * price) + respMultipleVal + respOnlyVal }}</strong>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <!-- services -->
                    <v-row no-gutters align="center" v-if="typeProd=='service'">
                        <v-col cols="12">
                            <v-btn
                                large
                                block
                                rounded
                                color="primary"
                                @click="sendServices"
                                class="text-capitalize"
                                :loading="loadingServ"
                            >
                                <strong>Reservar</strong>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
                <!-- edit -->
                <v-card-actions v-else>
                    <v-row no-gutters>
                        <v-col cols="6">
                            <div class="d-flex align-center">
                                <v-btn icon small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                    <v-icon dark>
                                        mdi-minus
                                    </v-icon>
                                </v-btn>
                                <v-text-field
                                    placeholder="Cantidad"
                                    color="primary"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    step="1"
                                    :max="stock"
                                    hide-details
                                    v-model="quantity"
                                    style="width:100px;max-width:100px;"
                                    @input="changeQuantity($event)"
                                ></v-text-field>
                                <v-btn icon small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-btn
                                large
                                block
                                rounded
                                color="primary"
                                @click="updateToCart"
                            >
                                <strong>Actualizar {{ money }} {{ (quantity * price) + respMultipleVal + respOnlyVal }}</strong>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog -->

        <!-- dialog cart -->
        <v-dialog
            v-model="openCart"
            transition="dialog-bottom-transition"
            scrollable
        >
            <v-card tile v-if="JSON.stringify(cart) != '{}'">
                <v-card-title class="container arrow-right">
                    <h3 class="mt-3 mb-5 text-h6 text-sm-h5 text-md-h4">Resumen del pedido</h3>
                    <v-fab-transition>
                        <v-btn
                            absolute
                            right
                            fab
                            small
                            style="top: 10px;"
                            @click="openCart=!openCart"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-fab-transition>
                </v-card-title>
                <v-card-text class="container">
                    <template>
                        <v-simple-table>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Producto
                                    </th>
                                    <th class="text-left">
                                        Cantidad
                                    </th>
                                    <th class="text-right">
                                        Precio Unitario
                                    </th>
                                    <th class="text-right">
                                        Total
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in cart" :key="i">
                                    <td class="text-left">
                                        {{ item.name }} <br>
                                        <small class="grey--text text-lighten-1">{{ item.complementsDetails }}</small>
                                    </td>
                                    <td class="text-left">{{ item.quantity }}x</td>
                                    <td class="text-right">{{ (item.quantity > 0)? (item.price / item.quantity) : 0 }}</td>
                                    <td class="text-right">{{ item.price }}</td>
                                    <td class="text-right">
                                        <div class="d-flex justify-end">
                                            <!-- <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="openDetailsEdit(item, i)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Editar</span>
                                            </v-tooltip> -->
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="removeItemOfCart(item.prodId, i)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Eliminar</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="blue-grey lighten-5">
                                    <td colspan="2">
                                        <strong class="text-sm-h6 text-md-h6">Subtotal {{ money }}</strong>
                                    </td>
                                    <td></td>
                                    <td class="text-right">
                                        <strong class="text-sm-h6 text-md-h6">{{ total }}</strong>
                                    </td>
                                </tr>
                                <tr class="blue-grey lighten-5">
                                    <td colspan="2">
                                        <strong class="text-sm-h6 text-md-h5">Total {{ money }}</strong>
                                    </td>
                                    <td></td>
                                    <td class="text-right">
                                        <strong class="text-sm-h6 text-md-h5">{{ (total>0)?total:0 }}</strong>
                                    </td>
                                </tr>
                            </tfoot>
                            </template>
                        </v-simple-table>
                    </template>
                    <!-- {{ cart }} -->
                    <v-row class="mt-8 mb-5">
                        <v-col cols="12" md="6" offset-md="3">
                            <v-btn
                                block
                                :large="!$vuetify.breakpoint.smAndDown"
                                rounded
                                color="primary"
                                @click="dialogPurchase=!dialogPurchase"
                            ><strong>Continuar</strong></v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card tile v-else>
                <v-card-title class="container arrow-center arrow-right">
                    <h3 class="mt-3 mb-5">Tu carrito esta vacío</h3>
                    <v-fab-transition>
                        <v-btn
                            absolute
                            right
                            fab
                            small
                            style="top: 10px;"
                            @click="openCart=!openCart"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-fab-transition>
                </v-card-title>
                <v-card-text>
                    <!-- {{ cart }} -->
                    <v-row class="mt-8 mb-5">
                        <v-col cols="12" md="6" offset-md="3">
                            <v-btn
                                block
                                large
                                rounded
                                color="primary"
                                @click="openCart = !openCart"
                            >Volver a la tienda</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- dialog cart end -->

        <!-- dialog purchase -->
        <v-dialog
            v-model="dialogPurchase"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-form @submit.prevent="sendOrder" ref="refOrder" lazy-validation>
                <v-card tile elevation="0">
                    <v-card-text class="pa-0">
                        <v-card-title class="py-3 blue-grey lighten-5">
                            Datos del cliente
                        </v-card-title>
                        <div class="pa-3">
                            <v-btn
                                color="primary"
                                @click="dialogClient=true"
                            >Buscar cliente</v-btn>
                            <!-- <v-btn
                                color="primary"
                                @click="() => {client.id='none'; client.name=''; client.lastname=''; tmpPhone=''; phoneCode=''; phoneNumber=''}"
                            >Nuevo cliente</v-btn> -->
                            <v-row class="mt-5">
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        label="Nombre(s) *"
                                        color="primary"
                                        outlined
                                        dense
                                        v-model="client.name"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                        label="Apellido(s) *"
                                        color="primary"
                                        outlined
                                        dense
                                        v-model="client.lastname"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <vue-tel-input-vuetify
                                        label="Celular (opcional)"
                                        color="primary"
                                        outlined
                                        dense
                                        :defaultCountry="iso2"
                                        :onlyCountries="[iso2]"
                                        :value="tmpPhone"
                                        @input="onInput"
                                    ></vue-tel-input-vuetify>
                                </v-col>
                            </v-row>
                        </div>

                        <v-card-title class="py-3 blue-grey lighten-5">
                            Dirección de entrega
                        </v-card-title>
                        <google-map
                            :center="{lat: centerLat, lng: centerLng}"
                            :zoom="13"
                            btn-color="primary"
                            @result-click="resultClickMap"
                            v-if="showMap"
                        ></google-map>
                        <div class="pa-3">
                            <v-text-field
                                label="Dirección de entrega *"
                                color="primary"
                                outlined
                                dense
                                v-model="deliveryAddress"
                                :rules="[rules.required]"
                            ></v-text-field>
                            <v-textarea
                                label="Aclaración de dirección"
                                placeholder="Ejm. Casa rojo con puerta de metal"
                                outlined
                                color="primary"
                                rows="3"
                                v-model="addressClarification"
                            ></v-textarea>
                        </div>

                        <v-card-title class="py-3 blue-grey lighten-5">
                            Método de pago
                        </v-card-title>
                        <div class="pa-3">
                            <v-radio-group
                                v-model="paymentMethod"
                                row
                                :rules="[rules.required]"
                            >
                                <v-radio
                                    v-if="enableUponDelivery"
                                    label="Pago Contraentrega"
                                    value="cash_payment"
                                    color="primary"
                                ></v-radio>
                                <v-radio
                                    v-if="enablePaymentMethod"
                                    label="Pago Qr/Transferencia Bancaria"
                                    value="bank_payment"
                                    color="primary"
                                ></v-radio>
                                <v-radio
                                    v-if="enablePaymentCard"
                                    label="Pago tarjeta de débito/crédito"
                                    value="card_payment"
                                    color="primary"
                                ></v-radio>
                                <v-radio
                                    v-if="enableVeMethod && iso2=='VE'"
                                    label="Pago por PagomóvilBDV"
                                    value="bank_ven"
                                    :color="btnColor"
                                ></v-radio>
                            </v-radio-group>
                            <div v-if="paymentMethod == 'bank_payment'" class="text-center">
                                <v-img
                                    :src="codePaymentMethod"
                                    max-width="300px"
                                    class="mx-auto mb-2"
                                ></v-img>
                                <!-- <a :href="codePaymentMethod" download :style="`color: ${btnColor}`">Descargar QR</a> -->
                                <v-btn
                                    :href="codePaymentMethod"
                                    download
                                    color="primary"
                                    dark
                                    small
                                    class="mb-2"
                                >
                                    Descargar QR
                                </v-btn>
                                <p class="mb-0">Banco: {{ payment.bank }}</p>
                                <p class="mb-0">Cuenta: {{ payment.account }}</p>
                                <p class="mb-0">Nombre: {{ payment.name }}</p>
                                <p class="mb-10">NIT: {{ payment.nit }}</p>
                            </div>
                            <div v-if="paymentMethod == 'bank_ven'" class="text-center">
                                <v-img
                                    :src="venPaymentMethod"
                                    max-width="300px"
                                    class="mx-auto mb-2"
                                ></v-img>
                                <p class="mb-0">Banco: {{ payment2.bank }}</p>
                                <p class="mb-0">Documento: {{ payment2.document }}</p>
                                <p class="mb-0">Nombre: {{ payment2.name }}</p>
                                <p class="mb-10">Tel: {{ payment2.tel }}</p>
                            </div>
                        </div>
                        <v-card-title class="py-3 blue-grey lighten-5">
                            Resumen de orden
                        </v-card-title>
                        <div class="pa-3">
                            <v-simple-table dense class="mb-5">
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left grey--text text--lighten-1">
                                            Cantidad
                                        </th>
                                        <th class="text-left grey--text text--lighten-1">
                                            Producto
                                        </th>
                                        <th class="text-right grey--text text--lighten-1">
                                            Precio
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in cart" :key="i">
                                        <td class="text-left">{{ item.quantity }}x</td>
                                        <td class="text-left">{{ item.name }}</td>
                                        <td class="text-right">{{ money }} {{ item.price }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>
                                            <strong class="text-h6">Subtotal</strong>
                                        </td>
                                        <td colspan="2" class="text-right">
                                            <strong class="text-h6">{{ money }} {{ total }}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong class="text-h5">Total</strong>
                                        </td>
                                        <td colspan="2" class="text-right">
                                            <strong class="text-h5">{{ money }} {{ (total>0)?total:0 }}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong class="text-h6">Pagado a cuenta</strong>
                                        </td>
                                        <td colspan="2" class="text-right">
                                            <v-text-field
                                                placeholder="Pagado a cuenta"
                                                dense
                                                outlined
                                                hide-details
                                                style="width:120px"
                                                class="ml-auto in-right"
                                                type="number"
                                                :rules="[rules.required]"
                                                v-model="balance"
                                            ></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong class="text-h6">Saldo</strong>
                                        </td>
                                        <td colspan="2" class="text-right">
                                            <strong class="text-h5">{{ money }} {{ (total>0)?(total-balance):0 }}</strong>
                                        </td>
                                    </tr>
                                </tfoot>
                                </template>
                            </v-simple-table>
                            <v-checkbox
                                v-model="dataPrch.remarkOrder"
                                color="primary"
                                label="Incluir un comentario para la orden"
                                hide-details
                            ></v-checkbox>
                            <!-- commentOrder -->
                            <v-textarea
                                placeholder="Ejm. Si es posible un poco de sal extra por favor."
                                outlined
                                color="primary"
                                rows="3"
                                v-model="dataPrch.commentOrder"
                                v-if="dataPrch.remarkOrder"
                                :rules="[rules.required]"
                            ></v-textarea>
                        </div>
                        <v-card-title class="py-3 blue-grey lighten-5">
                            Datos de facturación
                        </v-card-title>
                        <div class="pa-3">
                            <!-- invoice -->
                            <v-text-field
                                label="Razón social"
                                color="primary"
                                outlined
                                dense
                                v-model="businessName"
                            ></v-text-field>
                            <v-text-field
                                label="NIT / CI"
                                color="primary"
                                outlined
                                dense
                                v-model="document"
                            ></v-text-field>
                        </div>
                    </v-card-text>

                    <v-card-actions class="pa-3">
                        <v-row>
                            <v-col cols="4">
                                <v-btn
                                    rounded
                                    large
                                    text
                                    color="error"
                                    class="text-capitalize"
                                    block
                                    @click="dialogPurchase=!dialogPurchase"
                                >Cancelar</v-btn>
                            </v-col>
                            <v-col cols="8">
                                <v-btn
                                    rounded
                                    large
                                    color="primary"
                                    class="text-capitalize"
                                    block
                                    type="submit"
                                >Hacer pedido</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>

                    <!-- overlay -->
                    <v-overlay :value="loading" absolute opacity=".9" z-index="10">
                        <v-progress-circular
                            indeterminate
                            size="64"
                            color="primary"
                        ></v-progress-circular>
                    </v-overlay>
                    <!-- end overlay -->
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialog purchase END -->

        <!-- dialog -->
        <v-dialog
            v-model="dialogClient"
            width="300"
        >
            <v-card>
                <v-card-title>
                    <v-text-field
                        label="Buscar..."
                        color="primary"
                        outlined
                        dense
                        hide-details
                        v-model="txtClient"
                        @input="searchClient"
                    ></v-text-field>
                </v-card-title>
                <v-list v-if="listClients.length > 0">
                    <v-list-item v-for="(cl, o) in listClients" :key="o" @click="selectClient(cl.id)">
                        <v-list-item-content>
                            <v-list-item-title>{{ cl.name }} {{ cl.lastname }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-list v-else>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>Sin resultados</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogClient=false"
                    >Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- dialog END -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </v-container>
</template>
<script>
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
export default {
    components: {
        VueTelInputVuetify,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            // list data
            search: '',
            headers: [
                {
                    text: 'Producto',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                { text: 'Tipo', value: 'type' },
                { text: 'Categoría', value: 'categories' },
                { text: 'Cantidad', align:'center', value: 'quantity' },
                { text: 'Precio', value: 'price' }
            ],
            listProducts: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
            // cart
            cantProds: 0,
            total: 0,
            // dialog
            overlayProd: false,
            loadProd: true,
            dialogProd: false,
            prodId: '',
            bannerProd: '',
            galleryProd: [],
            nameProd: '',
            typeProd: '',
            descriptionProd: '',
            optionsProd: [],
            quantity: 1,
            price: null,
            subtotal: null,
            stock: 99999,
            dataExtra: '',
            respMultiple: [],
            respMultipleVal: 0,
            respOnly: [],
            respOnlyVal: 0,
            showRequired: false,
            showAlertRequired: false,
            // reservation
            menu1: false,
            menu2: false,
            fullName: '',
            phoneNumber: '',
            dateReservation: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            timeReservation: '14:00',
            loadingServ: false,
            // cart
            openCart: false,
            cart: {},
            tmpIndex: null,
            // purchase
            dialogPurchase: false,
            codePhone: '',
            dataPrch: {
                fullName: '',
                document: '',
                remarkOrder: false,
                commentOrder: ''
            },
            tmpPhone: '',
            phoneCode: '',
            phoneValid: false,
            phoneNumber: '',
            // location
            centerLat: -17.3751345,
            centerLng: -66.1844502,
            showMap: true,
            lat: null,
            lng: null,
            address: '',
            deliveryAddress: '',
            addressClarification: '',
            // balance
            balance: 0,
            // validation
            ifNewProd: true,
            rules: {
                required: v => !!v || 'El campo es requerido',
                requiredDates: v => v.length>0 || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            // clientes
            dialogClient: false,
            listClients: [],
            txtClient: '',
            client: {
                id: 'none',
                name: '',
                lastname: '',
                phone: ''
            },
            // pago
            paymentMethod: '',
            enableUponDelivery: false,
            enablePaymentMethod: false,
            enablePaymentCard: false,
            codePaymentMethod: '',
            payment: {
                bank: '',
                account: '',
                name: '',
                nit: ''
            },
            enableVeMethod: false,
            venPaymentMethod: '',
            payment2: {
                bank: '',
                document: '',
                name: '',
                tel: ''
            },
            // facturas
            businessName: '',
            document: ''
        }
    },
    props: ['slug', 'money', 'iso2', 'changePrice'],
    computed: {
        computedDateFormatted () {
            return this.formatDate(this.date)
        },
    },
    watch: {
        dialogProd(e) {
            if (!e) {
                this.respMultiple = []
                this.respMultipleVal = 0

                this.respOnly = []
                this.respOnlyVal = 0

                this.dataExtra = ''

                this.optionsProd = []
            }
        },
        dateReservation (val) {
            this.dateFormatted = this.formatDate(this.date)
        },
    },
    mounted() {
        this.getMainData()
        this.getListProducts()
        if (localStorage.getItem(this.slug)) {
            this.cart = JSON.parse(localStorage.getItem(this.slug))

            for (var [key, value] of Object.entries(this.cart)) {
                var tmpComplements = this.cart[key].complements
                this.cart[key].complementsDetails = ''
                if (tmpComplements.multi.length > 0) {
                    tmpComplements.multi.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
                if (tmpComplements.only.length > 0) {
                    tmpComplements.only.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
            }

            this.cantProds = Object.keys(this.cart).length;
            this.calculateTotal()
        }
        this.getLocation()
    },
    methods: {
        onInput(formattedNumber, { number, valid, country }) {
            this.phoneCode = '+'+country.dialCode
            this.phoneNumber = number.significant
            this.tmpPhone = number.international
            this.phoneValid = valid
        },
        /**
         *
         */
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        /**
         * get data
         */
        async getMainData() {
            await axios.get(`/data-order/${this.slug}`)
            .then((response) => {
                // console.log(response)
                if (response.data[0]) {
                    const contentPayment = JSON.parse(response.data[0].content)
                    this.enablePaymentMethod = (contentPayment.enable)?true:false
                    this.codePaymentMethod = contentPayment.codeQr
                    this.payment.bank = contentPayment.bank
                    this.payment.account = contentPayment.account
                    this.payment.name = contentPayment.name
                    this.payment.nit = contentPayment.nit
                }
                if (response.data[1]) {
                    const contentAddress = JSON.parse(response.data[1].content)
                    if (contentAddress.length > 0) {
                        this.addressOfPickUp = contentAddress[0]
                        this.listAddressOfPickUp = contentAddress
                    }
                }
                if (response.data[2]) {
                    const contentCard = JSON.parse(response.data[2].content)
                    this.enablePaymentCard = (contentCard.enable)?true:false
                }
                if (response.data[5]) {
                    const contentUponDelivery = JSON.parse(response.data[5].content)
                    console.log(contentUponDelivery);
                    this.enableUponDelivery = (contentUponDelivery.enable)?true:false
                }
                if (response.data[6]) {
                    const contentInvoice = JSON.parse(response.data[6].content)
                    this.enableInvoice = (contentInvoice.enable)?true:false
                }
                if (response.data[7]) {
                    const contentTable = JSON.parse(response.data[7].content)
                    this.enableTable = (contentTable.enable)?true:false
                }
                // if (this.enableUponDelivery) this.paymentMethod = 'cash_payment'
                // if (this.enablePaymentMethod) this.paymentMethod = 'bank_payment'
                // if (this.enablePaymentCard) this.paymentMethod = 'card_payment'
                if (response.data[14]) {
                    const contentPayment = JSON.parse(response.data[14].content)
                    this.enableVeMethod = (contentPayment.enable)?true:false
                    this.venPaymentMethod = contentPayment.imgBank
                    this.payment2.bank = contentPayment.bank
                    this.payment2.document = contentPayment.document
                    this.payment2.name = contentPayment.name
                    this.payment2.tel = contentPayment.tel
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListProducts()
        },
        changePage (event) {
            this.page = event;
            this.getListProducts()
        },
        cleanSearch () {
            if (this.txtSearch !== '') {
                this.listProducts = []
                this.page = 1
                this.txtSearch = ''
                this.getListProducts();
            }
        },
        async getListProducts () {
            this.overlay = true
            await axios.post(`/preventist/list-products?page=${this.page}&search=${this.txtSearch}&slug=${this.slug}`, {})
            .then(response => {
                // console.log(response)
                let tempCart = (localStorage.getItem(this.slug))?JSON.parse(localStorage.getItem(this.slug)):{}
                this.listProducts = response.data
                this.listProducts.forEach((element, i) => {
                    element.index = i
                    element.quantity = (tempCart[i]) ? tempCart[i].quantity : 0
                    element.subtotal = (tempCart[i]) ? tempCart[i].price : element.price
                });
                // this.listProducts = response.data.data
                // this.totalPage = response.data.last_page
                // this.pageTable = `Mostrando <strong>${response.data.from??0} - ${response.data.to??0}</strong> de un total de <strong>${response.data.total}</strong>`
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
        /**
         * prod
         */
        changeRespMultiple() {
            this.verifyRequireds()
            setTimeout(() => {
                var tmpListComplements = []
                this.optionsProd.forEach(element => {
                    element.tmpVal.forEach(val => {
                        const selectedId = document.getElementById(val)
                        const dataSelected = selectedId.getAttribute('data-details')
                        tmpListComplements.push(dataSelected)
                    });
                });
                // console.log(tmpListComplements);
                this.respMultipleVal = 0
                if (tmpListComplements.length > 0) {
                    tmpListComplements.forEach(el => {
                        // console.log(el);
                        let valSelected = el.split(':')
                        let tmpPrice = (+valSelected[1]) * (+valSelected[2])
                        this.respMultipleVal += tmpPrice
                    });
                }
                this.respMultiple = tmpListComplements
            }, 500);
        },
        changeRespOnly() {
            this.verifyRequireds()
            const tmpListOnly = []
            this.optionsProd.forEach(element => {
                if (element.tmpValOnly) {
                    tmpListOnly.push(element.tmpValOnly)
                }
            });

            this.respOnlyVal = 0
            if (tmpListOnly.length > 0) {
                tmpListOnly.forEach(el => {
                    let tmpPrice = +(el.split(':')[1])
                    this.respOnlyVal += tmpPrice
                });
            }
            // console.log(tmpListOnly);
            this.respOnly = tmpListOnly
        },
        verifyRequireds() {
            for (let i = 0; i < this.optionsProd.length; i++) {
                const element = this.optionsProd[i];
                if (element.isRequired) {
                    if (element.type == 'multiple') this.showRequired = (element.tmpVal.length<=0)
                    if (element.type == 'only') this.showRequired = (element.tmpValOnly==undefined)
                }
                if (this.showRequired) break
            }
        },
        openDetails(id) {
            this.loadProd = true
            this.dialogProd = true
            this.ifNewProd = true
            axios.get(`/show-product/${id}`)
            .then((response) => {
                // console.log(response);
                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.typeProd = response.data.type
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpVal = JSON.parse(element.values)
                        var multiRequired = []
                        var onlyRequired = undefined
                        tmpVal.forEach(val => {
                            val.quantity = 1
                        });
                        if (element.type == 'multiple') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    // multiRequired.push(`${val.name}:${val.price}:${val.quantity}`)
                                    multiRequired.push(`${val.name.replace(' ', '-')}_${val.price}`)
                                    setTimeout(() => {
                                        this.changeRespMultiple()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        if (element.type == 'only') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    onlyRequired = val.name+':'+val.price
                                    setTimeout(() => {
                                        this.changeRespOnly()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        // const selectRequired = `${opt.name.replace(' ', '-')}_${opt.price}`
                        this.optionsProd.push({
                            title: element.title,
                            type: element.type,
                            values: tmpVal,
                            select: element.select,
                            tmpVal: multiRequired,
                            tmpValOnly: onlyRequired,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price
                this.quantity = 1

                setTimeout(() => {
                    this.loadProd = false
                }, 800);
            })
            .catch((error) => {
                console.log(error);
            })
        },
        /**
         * edit
         */
        openDetailsEdit(prod, index) {
            this.tmpIndex = index
            this.loadProd = true
            this.dialogProd = true
            this.ifNewProd = false
            axios.get(`/show-product/${prod.prodId}`)
            .then((response) => {
                // console.log(response);
                this.optionsProd = []
                this.respMultipleVal = 0

                this.respOnlyVal = 0

                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpValues = JSON.parse(element.values)
                        var tmpValues2 = []
                        var tmpValues3 = []
                        var tmp2Val = []
                        var tmp2ValOnly = undefined
                        if (element.type == 'multiple') {
                            if (tmpValues.length > 0) {
                                tmpValues.forEach(el => {
                                    // let txtVal = el.name+':'+el.price
                                    let txtVal = el.name.replace(' ', '-')+'_'+el.price
                                    if (prod.complements.multi.length>0) {
                                        prod.complements.multi.forEach(multi => {
                                            // console.log(multi);
                                            const selectedVal = multi.split(':')
                                            const selectId = selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]
                                            if (selectId == txtVal) {
                                                this.respMultipleVal += (+el.price)*(+selectedVal[2])
                                                tmp2Val.push(txtVal)
                                            }
                                            tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                            tmpValues2[selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]] = +selectedVal[2]
                                            // tmpValues2.push({name:selectedVal[0], price:+selectedVal[1], quantity: +selectedVal[2]})
                                        });
                                        // if (prod.complements.multi.includes(txtVal)) {
                                        //     this.respMultipleVal += (+el.price)
                                        //     tmp2Val.push(txtVal)
                                        // }
                                    } else {
                                        tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                    }
                                });
                            }

                            tmpValues.forEach(val => {
                                for (const key in tmpValues2) {
                                    if (key == val.name.replace(' ', '-')+'_'+val.price) {
                                        tmpValues3.push({name:val.name, price:val.price, quantity:tmpValues2[key]})
                                    }
                                }
                            });
                        }
                        if (element.type == 'only') {
                            if (tmpValues.length > 0) {
                                tmpValues.forEach(el => {
                                    // let txtVal = el.name+':'+el.price
                                    let txtVal = el.name+':'+el.price
                                    // console.log(prod);
                                    if (prod.complements.only.length>0) {
                                        prod.complements.only.forEach(only => {
                                            // console.log(only);
                                            const selectedVal = only.split(':')
                                            // const selectId = selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]
                                            if (only == txtVal) {
                                                this.respOnlyVal += (+selectedVal[1])
                                                tmp2ValOnly = txtVal
                                            }
                                            // tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                            // tmpValues2[selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]] = +selectedVal[2]
                                            // tmpValues2.push({name:selectedVal[0], price:+selectedVal[1], quantity: +selectedVal[2]})
                                        });
                                        // if (prod.complements.multi.includes(txtVal)) {
                                        //     this.respMultipleVal += (+el.price)
                                        //     tmp2Val.push(txtVal)
                                        // }
                                    } else {
                                        // tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                    }
                                });

                            }
                            tmpValues3 = tmpValues
                            // console.log(tmpValues);
                            tmpValues.forEach(val => {
                                tmpValues3.quantity = 1
                            });
                        }
                        this.optionsProd.push({
                            title: element.title,
                            type: element.type,
                            values: tmpValues3,
                            select: element.select,
                            tmpVal: tmp2Val,
                            tmpValOnly: tmp2ValOnly,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price

                // default data
                this.dataExtra = prod.extra
                this.quantity = prod.quantity
                this.respMultiple = prod.complements.multi
                this.respOnly = prod.complements.only

                setTimeout(() => {
                    this.loadProd = false
                }, 500);
            })
            .catch((error) => {
                console.log(error);
            })
        },
        /**
         * remove item
         */
        removeItemOfCart(prod, i) {
            this.$confirm(
                '¿Está seguro de eliminar este elemento?',
                'Confirmar',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Sí',
                confirmButtonColor: this.btnColor,
                cancelButtonText: 'No',
                customClass: {
                    container: this.tmpFontFamily
                }
            }).then(res => {
                if (res) {
                    if (localStorage.getItem(this.slug)) {
                        const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                        const newCart = {}
                        for (var [key, value] of Object.entries(tmpCart)) {
                            // if (prod.toString() !== key) {
                            if (i.toString() !== key) {
                                newCart[key] = value
                            }
                        }
                        localStorage.setItem(this.slug, JSON.stringify(newCart))

                        this.updateCartTmp(JSON.stringify(newCart))
                        this.$notify.success('Se retiro el producto del carrito.');
                    }
                }
            });
        },
        removeItemOfCartTable(index) {
            if (localStorage.getItem(this.slug)) {
                const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                const newCart = {}
                for (var [key, value] of Object.entries(tmpCart)) {
                    // if (prod.toString() !== key) {
                    if (index.toString() !== key) {
                        newCart[key] = value
                    }
                }
                localStorage.setItem(this.slug, JSON.stringify(newCart))

                this.updateCartTmp(JSON.stringify(newCart))
                this.$notify.success('Se retiro el producto del carrito.');
            }
        },
        // chabge quantity
        changeQuantity(event) {
            if (+event > this.stock) {
                this.$fire({
                    title: 'Agotado',
                    text: `Stock agotado, solo queda ${this.stock} productos en almacén`,
                    type: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: this.primary,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.quantity = this.stock
                        // this.calcTotal()
                    }
                })
            }
            // this.calcTotal()
        },
        // change plus and minus
        changePlusAndMinus(type) {
            var tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.price) * ((+this.quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.price) * ((+this.quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) + 1
                    break
                default:
                    break
            }
            this.changeQuantity(this.quantity)
            // this.calcTotal()
        },
        changePlusAndMinusTable(type, i) {
            let tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.listProducts[i].price) * ((+this.listProducts[i].quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.listProducts[i].quantity = (+this.listProducts[i].quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.listProducts[i].price) * ((+this.listProducts[i].quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    // this.$set(this.listProducts[i], 'quantity', (+this.listProducts[i].quantity) + 1)
                    this.listProducts[i].quantity = (+this.listProducts[i].quantity) + 1
                    break
                default:
                    break
            }
            this.listProducts = [...this.listProducts]
            // this.changeQuantity(this.listProducts[i].quantity)
            if (this.listProducts[i].quantity > 0) {
                this.prodId = this.listProducts[i].id
                this.nameProd = this.listProducts[i].name
                this.typeProd = this.listProducts[i].type
                this.price = (this.listProducts[i].special_price) ? this.listProducts[i].special_price : this.listProducts[i].price
                this.quantity = this.listProducts[i].quantity
                this.tmpIndex = i
                this.listProducts[i].subtotal = this.listProducts[i].price * this.listProducts[i].quantity
                this.subtotal = this.listProducts[i].price * this.listProducts[i].quantity
                if (localStorage.getItem(this.slug)) {
                    this.updateToCart()
                } else {
                    this.addToCart()
                }
            } else {
                this.removeItemOfCartTable(i)
            }
        },
        changeQuantityTable(event, i) {
            if (+event > this.stock) {
                this.$fire({
                    title: 'Agotado',
                    text: `Stock agotado, solo queda ${this.stock} productos en almacén`,
                    type: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: this.primary,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.listProducts[i].quantity = this.stock
                        // this.calcTotal()
                    }
                })
            }
            this.listProducts = [...this.listProducts]
            if (this.listProducts[i].quantity > 0) {
                this.prodId = this.listProducts[i].id
                this.nameProd = this.listProducts[i].name
                this.typeProd = this.listProducts[i].type
                this.price = (this.listProducts[i].special_price) ? this.listProducts[i].special_price : this.listProducts[i].price
                this.quantity = this.listProducts[i].quantity
                this.tmpIndex = i
                this.listProducts[i].subtotal = this.listProducts[i].price * this.listProducts[i].quantity
                this.subtotal = this.listProducts[i].price * this.listProducts[i].quantity
                if (localStorage.getItem(this.slug)) {
                    this.updateToCart()
                } else {
                    this.addToCart()
                }
            } else {
                this.removeItemOfCartTable(i)
            }
        },
        changePriceCall(event, i) {
        console.log(this.listProducts[i].price);
        console.log(this.listProducts[i].quantity);
            this.listProducts = [...this.listProducts]
            if (this.listProducts[i].quantity > 0) {
                this.subtotal = +(this.listProducts[i].quantity * event)
                if (localStorage.getItem(this.slug)) {
                    this.updateToCart()
                } else {
                    this.addToCart()
                }
            } else {
                this.removeItemOfCartTable(i)
            }
        },
        /**
         * add cart
         */
        addToCart() {
            this.showAlertRequired = false
            if (this.showRequired) {
                this.showAlertRequired = true
                return
            }
            this.overlayProd = true
            const cart = {
                    prodId: this.prodId,
                    name: this.nameProd,
                    // price: this.price,
                    price: this.subtotal,
                    quantity: this.quantity,
                    extra: this.dataExtra,
                    complements: {
                        multi: this.respMultiple,
                        only: this.respOnly
                    }
                }

            if (localStorage.getItem(this.slug)) {
                const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                var size = Object.keys(tmpCart).length;
                tmpCart[this.tmpIndex] = cart
                // tmpCart[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCart))
            } else {
                let tmpCartInitial = {}
                tmpCartInitial[this.tmpIndex] = cart
                // tmpCartInitial[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCartInitial))
            }

            this.updateCartTmp(localStorage.getItem(this.slug))

            // setTimeout(() => {
            //     this.overlayProd = false
            //     this.dialogProd = false
            // }, 300);
            // setTimeout(() => {
            //     this.$confirm(
            //         '',
            //         'Producto agregado correctamente.',
            //         'success', {
            //         showCloseButton: true,
            //         reverseButtons: true,
            //         confirmButtonText: 'Ver carrito',
            //         cancelButtonText: 'Seguir comprando',
            //     }).then(res => {
            //         if (res) {
            //             this.openCart = true
            //         }
            //     });
            // }, 500);

            setTimeout(() => {
                this.$notify.success('Producto agregado correctamente.');
            }, 500);
        },
        /**
         * service
         */
        sendServices() {
            if (this.$refs.refService.validate()) {
                this.$fire({
                    title: 'Realizar reserva.',
                    text: 'Recibirá un mensaje por WhatsApp para coordinar mayor datos de su reserva.',
                    type: 'info',
                    confirmButtonText: 'Continuar',
                    confirmButtonColor: this.primary,
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(async resp => {
                    if (resp.value) {
                        this.loadingServ = true
                        const dataForm = new FormData()
                        dataForm.append('full_name', this.fullName)
                        dataForm.append('phone_number', this.phoneNumber)
                        dataForm.append('dates', this.dateReservation)
                        dataForm.append('time', this.timeReservation)
                        dataForm.append('extra', this.dataExtra)
                        dataForm.append('store', this.slug)
                        dataForm.append('prod_id', this.prodId)

                        await axios.post('/send-service', dataForm)
                        .then((response) => {
                            // console.log(response);
                            if (response.data == 'ok') {
                                this.$fire({
                                    title: 'Reserva realizado con éxito.',
                                    text: 'Su reserva fue realizado con éxito, en un momento recibirá un mensaje de whatsapp para coordinar con mayor detalle el servicio.',
                                    type: 'success',
                                    confirmButtonText: 'Continuar',
                                    confirmButtonColor: this.primary,
                                    reverseButtons: true,
                                    showCancelButton: false,
                                    customClass: {
                                        container: this.fontFamily
                                    }
                                }).then(resp => {
                                    if (resp.value) {
                                        window.location.href='/'+this.slug
                                    }
                                })
                                this.full_name = ''
                                this.phone_number = ''
                                this.dates = []
                                this.time = ''
                                this.extra = ''
                                this.dialogProd = false
                                this.loadingServ = false
                            }
                        })
                        .catch((error) => {
                            if (error.response.status == 404 || error.response.status == 500) {
                                this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                            }
                            this.loadingServ = false
                        })
                    }
                })
            }
        },
        /**
         * update cart
         */
        updateCartTmp(cart) {
            this.cart = JSON.parse(cart)

            // for (var [key, value] of Object.entries(this.cart)) {
            //     var tmpComplements = this.cart[key].complements
            //     this.cart[key].complementsDetails = ''
            //     if (tmpComplements.multi.length > 0) {
            //         tmpComplements.multi.forEach(element => {
            //             this.cart[key].complementsDetails += element.split(':')[0]
            //             this.cart[key].complementsDetails += ', '
            //         });
            //     }
            //     if (tmpComplements.only.length > 0) {
            //         tmpComplements.only.forEach(element => {
            //             this.cart[key].complementsDetails += element.split(':')[0]
            //             this.cart[key].complementsDetails += ', '
            //         });
            //     }
            // }

            this.cantProds = Object.keys(this.cart).length;
            this.calculateTotal()
        },
        /**
         * update cart
         */
        updateToCart() {
            this.showAlertRequired = false
            if (this.showRequired) {
                this.showAlertRequired = true
                return
            }
            this.overlayProd = true
            const cart = {
                    prodId: this.prodId,
                    name: this.nameProd,
                    // price: this.price,
                    price: this.subtotal,
                    quantity: this.quantity,
                    extra: this.dataExtra,
                    complements: {
                        multi: this.respMultiple,
                        only: this.respOnly
                    }
                }

            if (localStorage.getItem(this.slug)) {
                const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                tmpCart[this.tmpIndex] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCart))
            } else {
                let tmpCartInitial = {}
                tmpCartInitial[0] = cart
                // tmpCartInitial[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCartInitial))
            }

            this.updateCartTmp(localStorage.getItem(this.slug))

            setTimeout(() => {
                this.overlayProd = false
                this.dialogProd = false
            }, 300);
            // setTimeout(() => {
            //     this.$notify.success('Carrito actualizado con éxito.');
            // }, 500);
        },
        /**
         * calculate total
         */
        calculateTotal() {
            this.total = 0
            Object.keys(this.cart).forEach(key => {
                this.total += this.cart[key].price
            });
        },

        // map
        resultClickMap(resp) {
            this.lat = resp.lat
            this.lng = resp.lng
            this.address = resp.address
        },

        /**
         *
         * ---------------- order -----------
         *
         */
        async sendOrder() {
            if (this.tmpPhone) {
                if (!this.phoneValid) {
                    this.$alert('Número de celular inválido.')
                    return
                }
            }
            if (this.$refs.refOrder.validate()) {
                this.loading = true
                // send data
                const dataForm = new FormData()
                dataForm.append('store', this.slug)
                dataForm.append('payment_method', this.paymentMethod)
                // datos personales
                dataForm.append('id_client', this.client.id)
                dataForm.append('name', this.client.name)
                dataForm.append('lastname', this.client.lastname)
                dataForm.append('phone_number', this.phoneNumber??'')
                dataForm.append('code', this.phoneCode??'')
                dataForm.append('iso2', this.iso2??'')
                // resumen de orden
                dataForm.append('remark_order', (this.dataPrch.remarkOrder)?1:0)
                dataForm.append('comment_order', this.dataPrch.commentOrder)
                // facturas
                dataForm.append('business_name', this.businessName)
                dataForm.append('document', this.document)
                // carrito
                dataForm.append('cart', JSON.stringify(this.cart))
                dataForm.append('total', this.total)
                // location
                dataForm.append('lat', this.lat)
                dataForm.append('lng', this.lng)
                dataForm.append('address', this.address)
                dataForm.append('delivery_address', this.deliveryAddress)
                dataForm.append('address_clarification', this.addressClarification)
                dataForm.append('balance', this.balance)

                await axios.post('/preventist/send-order', dataForm)
                .then((response) => {
                    // console.log(response)
                    if (response.data === 'ok') {
                        this.$fire({
                            title: 'Pedido realizado con éxito.',
                            text: 'Su pedido fue realizado con éxito.',
                            type: 'success',
                            confirmButtonText: 'Continuar',
                            reverseButtons: true,
                            showCancelButton: false,
                        }).then(resp => {
                            if (resp.value) {
                                window.location.href='/preventist/dashboard'
                            }
                        })

                        this.clearData()
                    }
                    this.loading = false
                })
                .catch((error) => {
                    // console.log(error)
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
                // send data END
            } else {
                this.$notify.error('Campos requeridos vacios')
            }
        },
        clearData() {
            this.dataPrch.fullName = ''
            this.dataPrch.document = ''
            this.phoneNumber = ''
            this.phoneCode = ''
            this.dataPrch.remarkOrder = false
            this.dataPrch.commentOrder = ''

            this.dialogPurchase = false
            this.openCart = false
            this.cart = {}
            this.cantProds = 0
            this.calculateTotal()

            localStorage.removeItem(this.slug)
        },

        /***
         *
         *
         * clientes
         *
         *
         */
        async searchClient(event) {
            if (event != '') {
                await axios.post('/preventist/search-client', {txt: event})
                .then((response) => {
                    // console.log(response)
                    this.listClients = response.data
                })
                .catch((error) => {
                    // console.log(error)
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                })
            }
        },
        selectClient(id) {
            let tmpClient = this.listClients.filter(item => item.id===id)[0]
            this.client.id = tmpClient.id
            this.client.name = tmpClient.name
            this.client.lastname = tmpClient.lastname
            if (tmpClient.phone != '') {
                this.phoneNumber = tmpClient.phone
                this.tmpPhone = tmpClient.code+' '+tmpClient.phone
                this.phoneCode = tmpClient.code
                this.iso2 = tmpClient.iso2
            }
            // otro datos
            // console.log(tmpClient);
            if (tmpClient.presales.length > 0) {
                this.showMap = false
                this.centerLat = +tmpClient.presales[0].lat_map
                this.centerLng = +tmpClient.presales[0].lng_map
                this.deliveryAddress = tmpClient.presales[0].delivery_address
                this.addressClarification = tmpClient.presales[0].address_clarification
                this.paymentMethod = tmpClient.presales[0].payment_method
                this.businessName = tmpClient.presales[0].business_name
                this.document = tmpClient.presales[0].document
                setTimeout(() => {
                    this.showMap = true
                }, 300);
            }

            this.dialogClient = false
        },
        /**
         * get location
         */
        getLocation() {
            window.navigator.geolocation.getCurrentPosition(
            (pos)=>{
                var crd = pos.coords;
                this.centerLat = +crd.latitude
                this.centerLng = +crd.longitude
                this.showMap = true
            },
            (err)=>{
                console.warn('ERROR(' + err.code + '): ' + err.message)
                this.showMap = true
            },
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            });
        },
    },
}
</script>
<style lang="scss">
.in-center {
    input {
        text-align: center;
    }
}
.in-right {
    input {
        text-align: right;
    }
}
</style>
